import { useEffect, useState } from 'react';

/**
 * Verzögert einen sich schnell ändernden Wert (z.B. Sucheingaben), damit nicht
 * bei jedem Tastendruck eine Serveranfrage ausgelöst wird.
 */
export const useDebouncedValue = (value, delayMs = 350) => {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return debounced;
};

export default useDebouncedValue;
